/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @author Ujjwal Sana
 * useCourseIdModalStyles.js
 * Styles for useCourseIdModal components
 */

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import mixins from '../../../assets/styles/mixins.scss';

export const CourseIdDialogPaper = styled(Paper)({
  '&&': {
    width: '100%',
    maxWidth: '800px',
    borderRadius: '24px',
    padding: '48px 32px 32px 32px',
    position: 'relative',

    [mixins['md-sm-min']]: {
      padding: '48px'
    }
  }
});

export const CourseIdCloseButton = styled(IconButton)({
  '&&': {
    position: 'absolute',
    top: 16,
    right: 16
  }
});

export const CourseIdContentRoot = styled(DialogContent)({
  '&&': {
    padding: 0
  }
});

export const CourseIdSectionCard = styled('div')({
  '&&': {
    background: mixins.chalkWhiteFont
  }
});

export const CourseIdMainRow = styled('div')({
  '&&': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: 16,
    flexWrap: 'wrap',

    [mixins['md-sm-min']]: {
      flexWrap: 'unset'
    }
  }
});

export const CourseIdGroup = styled('div')({
  '&&': {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flexWrap: 'wrap',
    wordBreak: 'break-all',

    [mixins['md-sm-min']]: {
      flexWrap: 'unset',
      gap: 6
    }
  }
});

export const CourseIdLabel = styled('span')({
  '&&': {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize18,
    fontWeight: mixins.fontWeight600,
    whiteSpace: 'nowrap',
    color: mixins.color_text_primary,
    lineHeight: '28px'
  }
});

export const CourseIdText = styled('span')({
  '&&': {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize18,
    fontWeight: mixins.fontWeight400,
    color: mixins.color_text_primary,
    lineHeight: '28px'
  }
});

export const CourseIdCopyIconButton = styled(IconButton)({
  '&&': {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '1000px',
    border: `2px solid ${mixins.navyColor}`,
    height: '40px',
    padding: 12,
    width: '100%',

    [mixins['md-sm-min']]: {
      width: 'auto'
    },
    '&:hover': {
      backgroundColor: mixins.chalkWhiteFont
    }
  }
});

export const CourseIdIconTextWrapper = styled('div')({
  '&&': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    '& > svg': {
      fontSize: 16
    }
  }
});

export const CourseIdCopyText = styled('span')({
  '&&': {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 16,
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px',
    color: mixins.navyColor,
    paddingRight: 4,
    transform: 'translateY(-1px)'
  }
});
